module.exports = __webpack_public_path__ + "img/news5-1.c483309d.png";